<script setup lang="ts">
import LeIconButton from "@dsk/components/IconButton/LeIconButton.vue";
import LeTooltip from "@dsk/components/LeTooltip.vue";
import LeThumbs from "@dsk/icons/LeThumbs.vue";

const props = defineProps<{
  tooltip: string;
}>();

const emit = defineEmits<{
  click: [];
}>();

const onClick = () => {
  emit("click");
};
</script>

<template>
  <LeTooltip v-bind="$attrs" :text="props.tooltip" :margin-bottom="10">
    <LeIconButton size="l" :aria-label="props.tooltip" @click="onClick()">
      <LeThumbs role="presentation" />
    </LeIconButton>
  </LeTooltip>
</template>
